import querystring from 'querystring';
import ParcelexApi from '../../services/parcelex';
import logger from '../../lib/logger';

export default {
  async getUser(params) {
    return ParcelexApi.get(`user/me?${querystring.stringify(params)}`);
  },
  async getPreApprovedCredit() {
    return ParcelexApi
      .get('user/preApprovedCredit')
      .then((data) => data);
  },
  async getTransactionsWithProduct() {
    return ParcelexApi.get('user/transactionsWithProduct')
      .then((data) => data);
  },
  async getTransactionWithProduct({ transactionId }) {
    return ParcelexApi.get(`user/transactionsWithProduct/${transactionId}`)
      .then((data) => data);
  },
  async getOffers() {
    return ParcelexApi.get('/retargeting/offers/Celular e Smartphone')
      .then((data) => data)
      .catch((e) => logger.error(e));
  },
  async sendSecurityCode(type, source) {
    return ParcelexApi.post(`user/contacts/${type}/request/${source}`)
      .then((data) => data)
      .catch((e) => logger.error(e));
  },
  async changeContact(type, body) {
    return ParcelexApi.patch(`user/contacts/${type}`, body)
      .then((data) => data)
      .catch((e) => logger.error(e));
  },
  async preApprove({
    apiKey,
    env,
    cpf,
    phone,
    email,
    zipCode,
    trackId,
    price,
    campaign,
  }) {
    return ParcelexApi.post('/public/preApprove', {
      apiKey,
      env,
      cpf,
      phone,
      email,
      zipCode,
      source: 'site',
      trackId,
      price,
      campaign,
    });
  },
  async getLastCheckouts({ limit = 2 } = {}) {
    return ParcelexApi.get(`user/checkouts?limit=${limit}&bestCheckoutOption=true`)
      .then((data) => data)
      .catch((e) => logger.error(e));
  },
  async getUserTest(testName) {
    return ParcelexApi.get(`user/userTest/${testName}`)
      .then((data) => data)
      .catch((e) => logger.error(e));
  },
  async createUserTest(testName) {
    return ParcelexApi.post(`user/userTest/${testName}`)
      .then((data) => data)
      .catch((e) => logger.error(e));
  },
  async cancelContract(transactionId) {
    return ParcelexApi.post(`user/contract/${transactionId}/cancel/contact`)
      .then((data) => data)
      .catch((e) => logger.error(e));
  },
};
